import { react2angular } from 'react2angular';
import { AlertComponent } from 'directives/dashboard/ui-alert/react.ui-alert';


angular
    .module('directives')
//     .component('reactComponent', react2angular(MyComponent, ['callbackFn'],
// ['$http', 'AppIntegrationRestService', 'DevicesRepository']))
    .component('alertComponent', react2angular(AlertComponent, [], ['$state', '$rootScope']));



// WEBPACK FOOTER //
// ./scripts/react/registerDirectives.js